// extracted by mini-css-extract-plugin
module.exports = {"image":"BountyLogo_image__1mMEb"};